<template>
  <el-table :data="data" :height="height">
    <el-table-column prop="collectTime" label="时间" min-width="160">
      <template slot-scope="prop">
        <span>{{ prop.row.collectTime | formatDate }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="deviceName" label="设备" min-width="140"></el-table-column>
    <el-table-column prop="namech" label="鼠种"></el-table-column>
    <el-table-column
      prop="weight"
      label="重量(g)"
      width="80"
    ></el-table-column>
    <el-table-column
      prop="temperature"
      label="温度(℃)"
      width="80"
    ></el-table-column>
    <el-table-column
      prop="humidity"
      label="湿度(%)"
      width="80"
    ></el-table-column>
    <el-table-column label="播放">
      <template slot-scope="prop">
        <el-button
          type="primary"
          icon="el-icon-caret-right"
          circle
          @click="goPlay(prop.row)"
        ></el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { export_table_to_excel as exceljs } from '@/utlis/exportExcel'

export default {
  props: {
    data: {
      type: Array
    }
  },
  data() {
    return {
      height: 400
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.layout()
    })
  },
  methods: {
    layout() {
      this.height = this.$el.parentNode.offsetHeight
    },
    exportExcel(title) {
      exceljs(this.$el, title)
    },
    goPlay(row) {
      this.$emit('play', row)
    }
  }
}
</script>

<style lang="css" scoped></style>
